import { render, staticRenderFns } from "./ProjectCommentItem.vue?vue&type=template&id=756ec782"
import script from "./ProjectCommentItem.vue?vue&type=script&lang=js"
export * from "./ProjectCommentItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports